import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-btn',
  templateUrl: './btn.component.html',
  styleUrls: ['./btn.component.scss']
})
export class BtnComponent implements OnInit {

  // Define a body property of type any
  @Input() body: any = "مقدار مورد نظر رو وارد کنید";
  // Define a href for a tag's
  @Input() href: string = "";
  // Define a class for i tag
  @Input() btnClass: string = "";

  ngOnInit(): void {
  }

}

